module.exports = __webpack_public_path__ + "img/build-to-rent-2.dd44e429.jpg";